export default __webpack_public_path__ + "static/media/dole-juice-wood-bg@2x.92fd373f.png";